var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultSelect',{class:_vm.componentClass,attrs:{"title":"Оценка","options":_vm.options,"selectedItem":_vm.selectedItem,"onChange":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }